$(function() {
    $('.js-form-modal-login').validate({
        rules: {
            login: {
                email: true
            }
        },
        submitHandler: function(form) {
            $(form).find('[type="submit"]')
                .prop('disabled', true)
                .addClass('is-loading');

            Form.ajaxPost(form, function(data) {
                $('.js-login-error').hide();

                if (!data.status) {
                    $('.js-login-error')
                        .text(data.message)
                        .slideDown();

                    $(form).find('[type="submit"]')
                        .prop('disabled', false)
                        .removeClass('is-loading');
                } else {
                    $('.js-login-hide').slideUp(250, function(){
                        $('.js-login-success').slideDown(250);
                    });

                    setTimeout(function() {
                        location.reload();
                    }, 1500);
                }
            }, 'json');
        }
    });
});